import { Box, Grid2, Typography } from '@mui/material'
import { Outlet, useLocation } from 'react-router-dom';
import Header from '../components/layout/Header';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../store/store';
import { getDataSources, selectDataSourcesLoaded } from '../store/slices/dataSourcesSlice';
import BackgroundRight from '../assets/background-right.svg';
import BackgroundBottom from '../assets/background-bottom.svg';
import { getAllBookmarks, selectIfBookmarksLoaded } from '../store/slices/bookmarksSlice';
import { loadAllFeedback, selectIfFeedbackLoaded } from '../store/slices/feedbackSlice';
import FloatingChat from '../components/shared/FloatingChat';
import { ViewportContext } from '../contexts/viewportContext';
import { viewportContextValues } from '../utils/ViewportUtils';
import { APP_ROUTES } from '../constants/AppRoutes';

const IS_DEMO_MODE = process.env.REACT_APP_DEMO_MODE === 'true'

function Layout() {

    const location = useLocation();
    const isChatPage = location.pathname.startsWith(APP_ROUTES.ASK_GUARDIAN);

    const dispatch = useDispatch<AppDispatch>();

    const bookmarksLoaded = useSelector(selectIfBookmarksLoaded);
    const feedbackLoaded = useSelector(selectIfFeedbackLoaded);
    const dataSourcesLoaded = useSelector(selectDataSourcesLoaded);

    useEffect(() => {
        if (dataSourcesLoaded === false)
            dispatch(getDataSources())
    }, [dispatch, dataSourcesLoaded])

    useEffect(() => {
        if (bookmarksLoaded === false)
            dispatch(getAllBookmarks())
    }, [dispatch, bookmarksLoaded])

    useEffect(() => {
        if (feedbackLoaded === false)
            dispatch(loadAllFeedback())
    }, [dispatch, feedbackLoaded])

    return (
        <ViewportContext.Provider value={viewportContextValues}>
            <Grid2
                container
                flexDirection="column"
                alignItems="center"
                boxSizing={'border-box'}
                position={'relative'}>
                <Grid2
                    container
                    sx={{
                        width: '100vw',
                        position: 'fixed',
                        top: 0,
                        zIndex: 99999,
                        justifyContent: 'center',
                        alignItems: 'center',
                        boxSizing: 'border-box',
                        background: '#f2f9ff',
                        height: 'max(6vh, 64px)',
                    }}>
                    <Header></Header>
                </Grid2>
                <Grid2 size={{ xs: 0.5 }} sx={{
                    position: 'fixed',
                    top: 'max(64px, 6vh)',
                    right: 0,
                    zIndex: 2,
                    height: '100vh',
                    boxSizing: "border-box",
                    background: `linear-gradient(to left, #FFFFFF 0%,  transparent 100%)`,
                    backgroundSize: 'contain',
                    backgroundPosition: 'bottom right'
                }}>
                    <img src={BackgroundRight}
                        alt={'.'}
                        style={{
                            marginTop: '1vh',
                            display: 'block',
                            height: '100%',
                        }}
                    />
                </Grid2>
                <Grid2
                    sx={{
                        width: '100vw',
                        height: '100vh',
                        boxSizing: 'border-box',
                        display: 'flex',
                        flexDirection: 'column'
                    }}>
                    <Outlet></Outlet>
                    <Grid2 sx={{
                        position: 'fixed',
                        bottom: 0,
                        zIndex: 15,
                        width: '100vw',
                        height: 'max(5vh, 44px)',
                        background: `url('${BackgroundBottom}') no-repeat`,
                        backgroundPosition: '0 10px',
                        backgroundSize: '50vw',
                        display: 'grid',
                        alignContent: 'end',
                    }}>
                        {
                            IS_DEMO_MODE && <Box sx={{
                                position: 'relative',
                                bottom: '0.5rem',
                                width: 'max-content',
                                color: 'var(--text-light)',
                                paddingX: 2,
                            }}>
                                <Typography variant='body1' fontWeight={500}>
                                    Data is masked for demonstration purposes
                                </Typography>
                            </Box>
                        }
                    </Grid2>
                    {!isChatPage && <FloatingChat />}
                </Grid2>
            </Grid2>
            <svg style={{ position: 'absolute', top: 0, zIndex: -1 }}>
                <defs>
                    <linearGradient id="bookmark_feedback_elements_gradient" x1="20.2077" y1="15.4671" x2="-0.595418" y2="13.5257" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#5A4EB4" />
                        <stop offset="0.5" stopColor="#00A9B1" />
                        <stop offset="1" stopColor="#2E79B3" />
                    </linearGradient>
                </defs>
            </svg>
        </ViewportContext.Provider>
    )
}

export default Layout